import React from 'react'
import { Form } from 'antd';
import 'dayjs/locale/th';
import th_TH from 'antd/es/date-picker/locale/th_TH';
import { changeFormatdate } from '../../utils/formatDate';
import DatePicker from './DatePickerUC_BE';

const DatePickerUC = (props) => {
    const {
        name,
        label,
        isCustomError = false,
        labelError = null,
        showLabel = true,
        hidden,
        onChange,
        values,
        required,
        disabled,
        placeholder = 'กรุณาเลือก' + label,
        showPlaceholder = true,
        ...prop } = props
    return (
        <>
            <Form.Item
                name={name}
                label={showLabel ? (label + ' :') : ''}
                rules={required ? [{ required: true, message: 'กรุณากรอก ' + label }] : ''}
                validateStatus={(isCustomError && required) ? 'error' : undefined}
                help={(isCustomError && required) ? labelError : null}
            >
                <DatePicker
                    {...prop}
                    style={{ width: '100%' }}
                    className={'date-picker-rc'}
                    disabled={disabled}
                    onChange={onChange}
                    placeholder={showPlaceholder ? placeholder : ''}
                    locale={th_TH}
                    format={value => changeFormatdate(value)}
                // format="DD MMMM YYYY" // set the desired date format
                />

            </Form.Item>
        </>
    )
}

export default DatePickerUC